module.exports = __webpack_public_path__ + "img/key-solid.c9ec0880.svg";